<template>
  <div>
    <header-navigation></header-navigation>
    <div v-if="bannerContent">
      <banner :acf="bannerContent" :data="bannerContent"></banner>
    </div>
    <pageloader v-if="pageload" />

    <div class="container pt-4 px-1">
      <div class="d-flex justify-content-center">
        <div :class="['document-btn-cta btn-cta px-4 mr-3', { 'active-tab': activeAudience === 'PATIENT' }]"
          @click="setAudience('PATIENT')">
          Patient
        </div>
        <div :class="['document-btn-cta btn-cta px-4 mr-3', { 'active-tab': activeAudience === 'HCP' }]"
          @click="setAudience('HCP')">
          Healthcare Professional
        </div>
      </div>
    </div>

    <div style="border:1px solid lightgrey; border-top:10px solid #0D0A15; margin:40px 70px">

      <div v-if="currentCountry" class="container text-center"
        style="padding:15px;font-size: 18px; font-weight: 500; color: #2c2a2a">
        View documents for <b>{{ currentCountry }}</b>
      </div>

      <div class="blog-post-container" v-if="filteredContent.length">
        <div class="blog-post boxShadow" v-for="(doc, index) in filteredContent" :key="index">
          <div class="boxShadowContainer">
            <div class="document_title">
              <strong>{{ doc.document_title }}</strong>
            </div>

            <div class="download-section">
              <a :href="doc.document_cta" target="_blank" style="cursor:pointer">
                <span class="btn d-flex document-btn-cta" style="justify-content: center; align-items: center; gap:8px">
                  Download
                  <img src="@/assets/images/download_icon_black.png" alt="" class="download-icon" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <p v-else style="font-size:18px;text-align:center; padding:15px; margin: 0px 30px;min-height: 100px; display: flex; align-items: center; justify-content: center; color: #2c2a2a">
        {{ activeAudience == null && currentCountry != null ? 'Please select an audience' : '' }}
        {{ currentCountry != null && activeAudience != null && filteredContent.length == 0 ? 'No documents found for this audience in the selected country.' : '' }}
        {{ currentCountry == null ? 'Search country to view documents' : '' }}
      </p>

    </div>
  </div>
</template>

<script>
import headerNavigation from "./components/navigation/header.vue";
import footerNavigation from "./components/navigation/footer.vue";
import Pageloader from "./components/shared-support/pageloader.vue";
import banner from "./components/consumers/FSN_Banner_2026.vue";
import axios from "axios";
import _ from "lodash";

export default {
  components: { headerNavigation, footerNavigation, Pageloader, banner },
  data() {
    return {
      content: [],
      pageload: true,
      bannerContent: null,
      countries: [],
      filteredContent: [],
      currentCountry: null,
      activeAudience: null,
      availableAudiences: []
    };
  },

  async mounted() {
    window.astralPageApi = {
      setCountry: (country) => this.setCountry(country),
      setAudience: (audience) => this.setAudience(audience),
    };

    try {
      const response = await axios.get(
        `${process.env.VUE_APP_GPSPOD_ENDPOINT}/gps/home/get-wordpress-data?endpoint=get-page-by-slug&slug=astralfsn-2026`
      );
      const data = response.data;
      this.content = this.getAllInformation(data, "fsn-documents-2026");
      this.bannerContent = this.getComponentData(data, "support_banner_astral");
      if (this.bannerContent) this.bannerContent.countries = this.countries;
    } catch (e) {
      console.error("Error loading Astral FSN data:", e);
    } finally {
      this.pageload = false;
    }
  },

  methods: {
    parseCsv(csvText) {
      if (typeof csvText !== 'string' || !csvText) return [];

      const rows = [];
      let row = [];
      let field = '';
      let inQuotes = false;

      for (let i = 0; i < csvText.length; i++) {
        const char = csvText[i];
        const next = csvText[i + 1];

        if (inQuotes) {
          if (char === '"' && next === '"') {
            field += '"';
            i++;
          } else if (char === '"') {
            inQuotes = false;
          } else {
            field += char;
          }
        } else {
          if (char === '"') {
            inQuotes = true;
          } else if (char === ',') {
            row.push(field);
            field = '';
          } else if (char === '\r') {
            // ignore, handled by \n
          } else if (char === '\n') {
            row.push(field);
            rows.push(row);
            row = [];
            field = '';
          } else {
            field += char;
          }
        }
      }
      if (field.length > 0 || row.length > 0) {
        row.push(field);
        rows.push(row);
      }

      if (rows.length === 0) return [];

      const headers = rows[0].map(h => h.trim());
      return rows.slice(1)
        .filter(r => r.length > 1 || (r.length === 1 && r[0] !== ''))
        .map(r => {
          const obj = {};
          headers.forEach((h, idx) => {
            const value = r[idx] !== undefined && r[idx] !== null ? r[idx] : '';
            obj[h] = value.trim();
          });
          return obj;
        });
    },

    normalizeDocumentType(docType) {
      if (typeof docType !== 'string' || !docType.trim()) return undefined;
      const normalized = docType.trim().toLowerCase();

      if (normalized === 'patient letter') return 'PATIENT_LETTER';
      if (normalized === 'physician letter') return 'PHYSICIAN_LETTER';

      return undefined;
    },

    // Patient Letter ---- PATIENT audience
    // Physician Letter ---- HCP audience
    getAudienceForType(type) {
      if (type === 'PATIENT_LETTER') return 'PATIENT';
      if (type === 'PHYSICIAN_LETTER') return 'HCP';
      return undefined;
    },

    setAudience(audience) {
      this.activeAudience = audience;
      if (this.currentCountry) this.filterDocuments();
    },

    setCountry(country) {
      this.currentCountry = country || null;
      this.filteredContent = [];
      this.availableAudiences = [];
      if (!country) {
        this.activeAudience = null;
        return;
      }
      const available = new Set();
      this.content.forEach(layout => {
        layout.files.forEach(file => {
          if (file.country === country) {
            const type = this.normalizeDocumentType(file.document_type);
            const audience = this.getAudienceForType(type);
            if (audience) available.add(audience);
          }
        });
      });
      this.availableAudiences = Array.from(available);
      if (this.activeAudience) this.filterDocuments();
    },

    getComponentData(data, componentName) {
      if (!data.fields) return null;
      const component = _.find(data.fields, ["acf_fc_layout", componentName]);
      return component ? { ...component[componentName] } : null;
    },

    getAllInformation(data, componentName) {
      if (!data.fields) return [];

      const layout = _.find(data.fields, ["acf_fc_layout", componentName]);
      const countrySet = new Set();

      if (layout && typeof layout['docs-as-csv'] === 'string') {
        const parsedRows = this.parseCsv(layout['docs-as-csv']);

        const cleanFiles = parsedRows.filter(row => {
          const validCountry = typeof row.country === 'string' && row.country.trim();
          const validCta = typeof row.document_cta === 'string' && row.document_cta.trim();
          if (!validCountry || !validCta) {
            console.warn('[AstralFSN] Skipping row with missing country/CTA:', row);
            return false;
          }
          return true;
        });

        cleanFiles.forEach(file => countrySet.add(file.country));

        this.countries = Array.from(countrySet).sort();

        return [{ files: cleanFiles }];
      }
      return [];
    },

    filterDocuments() {
      const country = this.currentCountry;
      const audience = this.activeAudience;

      if (!country || !audience) {
        this.filteredContent = [];
        return;
      }
      const sourceFiles = (this.content[0] && this.content[0].files) || [];

      this.filteredContent = sourceFiles.filter(file => {
        if (file.country !== country) return false;

        const type = this.normalizeDocumentType(file.document_type);
        const fileAudience = this.getAudienceForType(type);

        // Patient tab only Patient Letters
        // Healthcare Professional tab - Patient Letter and Physician Letter
        if (audience === 'PATIENT') return fileAudience === 'PATIENT';
        if (audience === 'HCP') return fileAudience === 'HCP' || fileAudience === 'PATIENT';
        return false;
      });
    }
  }
};
</script>

<style scoped>
.active-tab {
  background-color: #0D0A15 !important;
  color: #fff !important;
  border-color: #0D0A15 !important;
}

.document-btn-cta {
  padding: 0.5rem 1rem;
  background-color: #fff;
  color: #0D0A15;
  font-size: 15px;
  cursor: pointer;
  border: 1px solid lightgrey;
  transition: 0.2s;
}
</style>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.blog-post-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  margin: 20px auto;
}

.blog-post {
  padding: 1.75rem;
  border: 1px solid #f4f4f4;
  background: #ffffff;
  box-shadow: -1px 0.25rem 12px 2px rgb(0 0 0 / 13%);
  min-height: 180px;
  min-width: 300px;
  max-width: 300px;
}

.boxShadow {
  position: relative;
  background-color: #fff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  padding: 14px;
  border-radius: 4px;
  border-top: 4px solid #0d0a15;
  width: 100%;
}

.boxShadowContainer {
  display: flex;
  flex-direction: column;
  min-height: 128px;
  justify-content: space-between;
}

.document_title {
  min-height: 42px;
  text-align: left;
  display: flex;
  align-items: center;
}

.document_title strong {
  line-height: 1.6;
  color: #020202;
  font-size: 16px;
}

.download-section {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

.download-icon {
  height: 20px;
  cursor: pointer;
}
</style>